<template>
  <q-dialog
    v-model="shown"
    :maximized="true"
  >
    <q-card>
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Select Title
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <title-plan-list
          class="q-mx-lg"
          :booking-week="bookingWeek"
          :selector="true"
          @select="value => { $emit('select', value); shown = false }"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import TitlePlanList from 'src/modules/admin/booking-week/components/TitlePlanList'

export default {
  name: 'NotesDialog',
  components: { TitlePlanList },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    bookingWeek: {
      type: Object,
      required: true
    }
  },
  emits: ['select', 'update:model-value'],
  data () {
    return {
      shown: false
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show (id) {
      this.id = id
      this.shown = true
    }
  }
}

</script>

<style lang="scss" scoped></style>
